import vdh15 from "../../../../assets/images/productos/vdh/VDH 15 (1).png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI1.png";
import pic2 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI2.png";

import { useTranslation } from "react-i18next";

function VDH15() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "17,5 / 24"],
        [t("corrienteNominal"), "A", "1.250 / 2.000 / 2.500 / 3.150"],
        [t("poderDeInterrupcion"), "kA", "20 / 25 / 31,5"],
        [t("corrienteBreveDuracion"), "kA (3sec)", "31,5"],
        [t("poderDeCierre"), "kA", "50 / 63 / 78"],
        [t("tensionDeImpulso"), "kV", "95 / 170"],
        [t("frecuenciaNominal"), "Hz", "50/60"],
        [t("tiempoDeCierreNominal"), "msec", "< 60"],
        [t("tiempoDeAperturaNominal"), "msec", "< 40"],
        [t("tiempoDeArcoNominal"), "msec", "5/15"]
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "1.800"],
        [t("alto"), "mm", "2.780"],
        [t("profundidad"), "mm", "1.800"],
      ]}
      nombreProducto={"VDH 15"}
      fotoProducto={vdh15}
      descripcionProducto={t("vdh-15.titulo_descripcion")}
      caracteristicas={[
        t("vdh-15.bullet1"),
        t("vdh-15.bullet2"),
        t("vdh-15.bullet3"),
        t("vdh-15.bullet4")
      ]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20VDH.pdf'}
    />
  );
}

export default VDH15;